var DailyRoundProgressBarComponent = (function () {
    function DailyRoundProgressBarComponent() {
        this.progress = 0;
        this.progressCount = 0;
        this.color = '#E6A43D';
        this.strokeWidth = 30;
        this.roundedCorners = true;
    }
    DailyRoundProgressBarComponent.prototype.calculateDashArray = function () {
        var circumference = 2 * Math.PI * 85;
        var progressOffset = (circumference * this.progress) / 100;
        return progressOffset + " " + circumference;
    };
    return DailyRoundProgressBarComponent;
}());
export { DailyRoundProgressBarComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/components/daily-round-progress-bar.component.ts.pre-build-optimizer.js